'use strict';

define('vb/private/stateManagement/containerExtension',[
  'vb/private/stateManagement/container',
  'vb/private/log',
  'vb/private/constants',
  'vb/private/monitoring/loadMonitorOptions',
], (Container, Log, Constants, LoadMonitorOptions) => {
  const logger = Log.getLogger('/vb/stateManagement/containerExtension', [
    // Register a custom logger
    {
      name: 'greenInfo',
      severity: 'info',
      style: 'green',
    },
  ]);
  /**
   * ContainerExtension class
   */
  class ContainerExtension extends Container {
    constructor(extension, parent, path, base, className = 'ContainerExtension') {
      super(base.name, parent, className);

      // Make base and extensionId readonly properties for safety
      Object.defineProperties(this, {
        // a reference to the base object
        base: {
          value: base,
          enumerable: true,
        },
        extensionId: {
          value: extension.id,
          enumerable: true,
        },
        needsExtension: {
          value: !extension.isOptimized,
          enumerable: true,
        },
      });

      this.baseUrl = `${Constants.EXTENSION_PATH}${this.extensionId}/`;

      // The path to resources inside the self section (new artifacts) of the extension
      // Cannot use the require mapping because images are not loaded using requirejs
      // Used to define the value of the path variable on $extension
      this.absoluteUrl = `${extension.ui.baseUrl}/${Constants.ExtensionFolders.SELF}/`;

      this.fullPath = this.base.fullPath;

      this.requirePath = path;
      this.view = {};
      this.log = logger;
    }

    /**
     * Returns the name of the function used to load the chain file.
     *
     * @returns {string}
     */
    // eslint-disable-next-line class-methods-use-this
    get chainLoaderName() {
      return 'getExtensionTextResource';
    }

    /**
     * Used by events.
     * @returns {boolean}
     * @override
     */
    // eslint-disable-next-line class-methods-use-this
    isExtension() {
      return true;
    }

    /**
     * The router path is the same for base and extension.
     * @return {String} the path
     */
    getPath() {
      return this.base && this.base.fullPath;
    }

    /**
     * Add the extension id as part of the name to make it unique between
     * multiple extensions.
     * @return {String} a new scope name
     */
    getNewScopeName() {
      return `${this.className}/${this.extensionId}/${this.fullPath}`;
    }

    initDefault(definition) {
      const def = definition;

      def.extensions = def.extensions || {};

      super.initDefault(definition);
    }

    load() {
      const mo = new LoadMonitorOptions(`${this.className}Load`, `${this.className} load ${this.fullPath}`, this);
      // eslint-disable-next-line arrow-body-style
      return this.log.monitor(mo, (extensionLoadTimer) => {
        return this.loadDescriptor()
          .then(() => {
            this.log.greenInfo(this.className, this.fullPath, 'LOADED.', extensionLoadTimer());
          })
          .catch((error) => {
            extensionLoadTimer(error);
            throw error;
          });
      });
    }

    // eslint-disable-next-line class-methods-use-this
    checkAccess() {
      return Promise.resolve();
    }
  }

  return ContainerExtension;
});

